import firebase from 'firebase/app'

import * as crud from './crud'


export const getTransactions = (options = {}) => {
  const db = firebase.firestore()

  return crud.getAll(db.collection('transactions'), {
    ...options,
    map: async (doc, data) => {
      const [shop, user] = await Promise.all([
        data.shop_id ? crud.get(db.collection('shops').doc(data.shop_id)) : null,
        data.user_id ? crud.get(db.collection('users').doc(data.user_id)) : null,
      ])

      return {
        ...crud.getDefaultMapping(doc, data),
        user,
        shop,
      }
    },
  })
}


export const getTransactionsByUser = async (userId, options = {}) => {
  const db = firebase.firestore()

  return crud.getAll(db.collection('users').doc(userId).collection('transactions'), {
    ...options,
    map: async (doc, data) => {
      const shop = data.shop_id ? await crud.get(db.collection('shops').doc(data.shop_id)) : {}

      return {
        ...crud.getDefaultMapping(doc, data),
        shop,
      }
    },
  })
}


export const getRefundTransactions = async (options = {}) => {
  const db = firebase.firestore()

  return crud.getAll(db.collection('transactions').where('refund', '==', true), {
    ...options,
    limit: options.limit || 50,
    map: async (doc, data) => {
      const user = data.user_id ? await crud.get(db.collection('users').doc(data.user_id)) : {}
      const shop = data.shop_id ? await crud.get(db.collection('shops').doc(data.shop_id)) : {}

      return {
        ...crud.getDefaultMapping(doc, data),
        user,
        shop,
      }
    },
  })
}


export const getPendingRefundTransactions = async (options = {}) => {
  const db = firebase.firestore()

  return crud.getAll(db.collection('transactions').where('success', '==', true).where('refund', '==', false), {
    ...options,
    limit: options.limit || 50,
    map: async (doc, data) => {
      const user = data.user_id ? await crud.get(db.collection('users').doc(data.user_id)) : {}
      const shop = data.shop_id ? await crud.get(db.collection('shops').doc(data.shop_id)) : {}

      return {
        ...crud.getDefaultMapping(doc, data),
        user,
        shop,
      }
    },
  })
}


export const getTransactionsByMarket = async (marketId, options = {}) => {
  const {
    refund,
  } = options
  const db = firebase.firestore()
  let ref = db.collection('transactions').where('shop_id', '==', marketId)

  if (typeof refund === 'boolean') {
    ref = ref.where('refund', '==', refund)
  }

  return crud.getAll(ref, {
    ...options,
    map: async (doc, data) => {
      const user = data.user_id ? await crud.get(db.collection('users').doc(data.user_id)) : {}

      return {
        ...crud.getDefaultMapping(doc, data),
        user,
      }
    },
  })
}
